module.exports = __webpack_public_path__ + "static/media/appmobile.7f3c3b91.webp";